import { motion } from "framer-motion";

const Hero = () => {
  return (
    <section className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden px-4 py-16">
      <div className="relative z-10 text-center">
        <motion.p
          className="mb-2 text-lg font-great-vibes tracking-[0.3em] text-gold font-medium md:text-base"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 9.7 }}
        >
          please join
        </motion.p>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, delay: 9.2 }}
        >
          <h1 className="font-display text-5xl font-medium tracking-wide text-[hsl(var(--foreground))] md:text-7xl lg:text-8xl">
            Isabella
          </h1>
          <p className="ornament-line my-4 inline-block font-display text-2xl italic text-gold md:text-3xl">
            &
          </p>
          <h1 className="font-display text-5xl font-medium tracking-wide text-[hsl(var(--foreground))] md:text-7xl lg:text-8xl">
            Nathaniel
          </h1>
        </motion.div>

        <motion.div
          className="mt-4"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 9.7 }}
        >
          <p className="mb-2 text-xl font-great-vibes text-gold tracking-[0.25em] text-muted-foreground md:text-xl">
            to celebrate their engagement
          </p>
          <div className="mx-auto h-px w-24 bg-linear-to-r from-transparent via-gold to-transparent" />
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
